import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
  CircularProgress,
  Slide,
  Container,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Checkbox,
  List,
  ListItemText,
  Switch,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  IconButton,
  Tooltip,
  CardActionArea,
  Alert,
  Stack,
  Chip
} from "@mui/material";
import { ThumbUp, ThumbDown, Facebook, Twitter, LinkedIn } from "@mui/icons-material";
import SentimentSatisfiedOutlinedIcon from '@mui/icons-material/SentimentSatisfiedOutlined';
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined';
import { motion } from "framer-motion";
import Grid from "@mui/material/Grid2";
import { Phone, Email, LocationOn } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { Form } from "react-router-dom";
import { useParams, useLocation } from "react-router-dom";
import TopHeader from './subcomponents/TopHeader';
import BottomFooter from './subcomponents/BottomFooter';
import {
    CheckCircle as CheckCircleIcon,
    AccessTime as AccessTimeIcon,
    Person as PersonIcon,
    CalendarToday as CalendarIcon,
    Store as StoreIcon,
    ErrorOutline as ErrorIcon
  } from '@mui/icons-material';
function PickupConfirm() {
  const [clinicData, setClinicData] = useState(null);
  const [feedbackType, setFeedbackType] = useState(null);
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone: "",
    preferredContact: "email",
  });
  const location = useLocation(); // Get full URL details.
  // Parse query parameters
  const searchParams = new URLSearchParams(location.search);
  const satisfactionStatus = searchParams.get("s"); // Check if 'satisfied' is present
  const [loading, setLoading] = useState(true);
  const [confirmationStatus, setConfirmationStatus] = useState('success'); // 'success', 'error', 'expired'
  const [patientInfo, setPatientInfo] = useState({
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
    cellPhone: '(555) 123-4567',
    homePhone: '(555) 987-6543',
    pickupDate: 'April 10, 2025',
    pickupTime: '2:30 PM',
    orderNumber: 'CL-2025-04578',
    storeLocation: 'Main Street Optical'
  });
  useEffect(() => {
    const demoData = {
      clinicName: "Delta Eye Clinic",
      primaryColor: "#E3F2FD",
      secondaryColor: "#00796B",
      logo: "https://www.eyeconx.net/clinic/templates/logos/delta_eye_logo.png",
      address: "123 Main Street, Cityville, ST 12345",
      phone: "(123) 456-7890",
      fax: "(123) 456-7899",
      backgroundImage: "https://source.unsplash.com/1600x900/?medical,clinic", // Sample background image
    };
    setClinicData(demoData);
    // if isSatisfied then setfeedback type to positive
    if (satisfactionStatus === "satisfied") {
      setFeedbackType("positive");
    } 
    if (satisfactionStatus === "not-satisfied") {
      setFeedbackType("negative");
    } 
     // Simulate API delay
     setTimeout(() => {
        setLoading(false);
        // Here you would set patient data from API response
      }, 1500);
   }, []);

  if (!clinicData) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#F2F7FC",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  
  if (loading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '50vh' }}>
        <CircularProgress size={60} thickness={4} />
        <Typography variant="h6" sx={{ mt: 3 }}>
          Verifying your confirmation...
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        backgroundImage: `url(${clinicData.backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: 3,
      }}
    >
    {clinicData && <TopHeader clinicData={clinicData} />}
      {/* Form Section */}
      <Slide direction="up" in={true} mountOnEnter unmountOnExit>
       
         <Paper
                            elevation={4}
                            sx={{
                                padding: 4,
                                maxWidth: "lg",
                                width: "100%",
                                borderRadius: 3,
                                textAlign: "left",
                                backgroundColor: "#fff",
                                minHeight:"70vh",
                                boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)",
                                marginTop: { xs: 5, md: 14 },
                            }}
                            >

<Box>
      {confirmationStatus === 'success' && (
        <>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <CheckCircleIcon color="success" sx={{ fontSize: 64, mb: 2 }} />
            <Typography variant="h4" gutterBottom color="primary" fontWeight="500">
              Pickup Confirmed!
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              Thank you for confirming your contact lens pickup.
            </Typography>
          </Box>

          <Alert severity="info" sx={{ mb: 4 }}>
            Please bring a valid photo ID when picking up your contact lenses.
          </Alert>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" color="primary" gutterBottom>
              Patient Information
            </Typography>
            <Grid container spacing={2} >
              <Grid xs={12} md={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <PersonIcon color="action" sx={{ mr: 1 }} />
                  <Typography variant="body1">
                    <strong>Name:</strong> {patientInfo.firstName} {patientInfo.lastName}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <CalendarIcon color="action" sx={{ mr: 1 }} />
                  <Typography variant="body1">
                    <strong>Pickup Date:</strong> {patientInfo.pickupDate} at {patientInfo.pickupTime}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <StoreIcon color="action" sx={{ mr: 1 }} />
                  <Typography variant="body1">
                    <strong>Location:</strong> {patientInfo.storeLocation}
                  </Typography>
                </Box>
              </Grid>
              <Grid xs={12} md={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Typography variant="body1">
                    <strong>Email:</strong> {patientInfo.email}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Typography variant="body1">
                    <strong>Cell Phone:</strong> {patientInfo.cellPhone}
                  </Typography>
                </Box>
                {patientInfo.homePhone && (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="body1">
                      <strong>Home Phone:</strong> {patientInfo.homePhone}
                    </Typography>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" color="primary" gutterBottom>
              Order Details
            </Typography>
            <Box sx={{ mb: 2 }}>
              <Typography variant="body1">
                <strong>Order Number:</strong> {patientInfo.orderNumber}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <AccessTimeIcon color="action" sx={{ mr: 1 }} />
              <Typography variant="body1">
                <strong>Status:</strong>
                <Chip 
                  label="Ready for pickup" 
                  color="success" 
                  size="small" 
                  sx={{ ml: 1 }}
                />
              </Typography>
            </Box>
          </Box>

          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
              <Button 
                variant="outlined" 
                color="primary"
                startIcon={<CalendarIcon />}
              >
                Add to Calendar
              </Button>
              <Button 
                variant="contained" 
                color="primary"
              >
                View My Account
              </Button>
            </Stack>
          </Box>
        </>
      )}

      {confirmationStatus === 'error' && (
        <Box sx={{ textAlign: 'center', my: 4 }}>
          <ErrorIcon color="error" sx={{ fontSize: 64, mb: 2 }} />
          <Typography variant="h5" gutterBottom color="error">
            Invalid Confirmation Link
          </Typography>
          <Typography variant="body1" paragraph>
            We couldn't verify your confirmation. The link may be invalid or has already been used.
          </Typography>
          <Button variant="contained" color="primary">
            Contact Support
          </Button>
        </Box>
      )}

      {confirmationStatus === 'expired' && (
        <Box sx={{ textAlign: 'center', my: 4 }}>
          <ErrorIcon color="warning" sx={{ fontSize: 64, mb: 2 }} />
          <Typography variant="h5" gutterBottom color="warning.dark">
            Confirmation Link Expired
          </Typography>
          <Typography variant="body1" paragraph>
            This confirmation link has expired. Please request a new confirmation link.
          </Typography>
          <Button variant="contained" color="primary">
            Request New Link
          </Button>
        </Box>
      )}
    </Box>
                            </Paper>
      </Slide>

      {clinicData && <BottomFooter clinicData={clinicData} />}
    </Box>
  );
}

export default PickupConfirm;
